import { UserService } from './../../services/user.service';
import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ttm} from '../../classes/ttm';
import {TtmTicketService} from '../../services/ttm-ticket.service';
import {TtmTicket} from '../../classes/ttm-ticket.class';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Project} from '../../classes/project';
import {TtmType} from '../../classes/ttmtype';
import {TtmStatus} from '../../classes/ttmstatus';
import {CodaltComponent} from '../codalt/codalt.component';

@Component({
    selector: 'app-ttm-ticket-dialog',
    templateUrl: './ttm-ticket-dialog.component.html',
    styleUrl: './ttm-ticket-dialog.component.scss'
})
export class TtmTicketDialogComponent extends CodaltComponent implements OnInit {
    showReportForm = false;
    showAssigneeField = false;
    reportForm = new FormGroup({
        type: new FormControl(TtmTicketTypeOptions.other, Validators.required),
        comment: new FormControl(''),
        ttm_id: new FormControl(),
        department: new FormControl(null, Validators.required),
        assignee_id: new FormControl(null)
    });

    typeOptions = TtmTicketTypeOptions;

    departmentOptions = TtmTicketDepartmentOptions;
    assigneeOptions = [];

    constructor(private matSnackBar: MatSnackBar,
                public dialogRef: MatDialogRef<TtmTicketDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    ttm: Ttm,
                    project: Project,
                    ttmTypes: TtmType[],
                    ttmStatuses: TtmStatus[]
                },
                private ttmTicketService: TtmTicketService,
                private userService: UserService) {
        super();
    }

    ngOnInit() {
        this.reportForm.controls.ttm_id.setValue(this.data.ttm.id);

        this.subscriptions.add(
            this.reportForm.controls.department.valueChanges.subscribe({
                next: (value) => {
                    if (value === 'technical') {
                        this.showReportForm = true;
                        this.showAssigneeField = false;
                        this.reportForm.controls.type.setValue(null);
                    } else if (value === 'design') {
                        this.showReportForm = false;
                        this.showAssigneeField = false;
                        this.reportForm.controls.type.setValue(TtmTicketTypeOptions.other);
                    } else if (value === 'projectcoordinator') {
                        this.showAssigneeField = true;
                        this.showReportForm = false;
                        this.reportForm.controls.assignee_id.setValue(this.data.project.projectmanager_id);
                    }
                }
            })
        );

        this.subscriptions.add(this.userService.getManagers().subscribe(response => {
            this.assigneeOptions = response.data;
        }));
    }

    onSubmit(): void {
        if (this.reportForm.valid) {
            this.ttmTicketService.saveTicket(this.reportForm.value as TtmTicket).subscribe(response => {
                this.matSnackBar.open('TVM is succesvol gemeld!', null, {duration: 2000});
                this.dialogRef.close(response);
            });
        }
    }

    onClose(): void {
        this.dialogRef.close();
    }
}

export const TtmTicketTypeOptions = {
    incorrectLocation: 'Locatie is onjuist',
    incorrectImage: 'Afbeelding is onjuist',
    incorrectIcon: 'Raar teken in tekst (font/icoon probleem)',
    tooManyMeasures: 'Te veel maatregelen samengevoegd',
    tooFewMeasures: 'Te weinig maatregelen samengevoegd',
    incorrectType: 'Onjuist type',
    shouldNotBeDrawn: 'Had niet getekend moeten worden',
    incorrectDrawn: 'Onjuist getekend op kaart',
    other: 'Overig'
};

export const TtmTicketDepartmentOptions = {
    technical: 'Techniek (Codalt)',
    design: 'Ontwerp (Tekenaar)',
    projectcoordinator: 'Projectcoördinator'
}

export const TtmTicketStatusOptions = {
    new: 'Nieuw',
    in_progress: 'In behandeling',
    resolved: 'Afgehandeld',
};
